import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { WebApiService } from '../../shared/services/web-api.service';
import * as jsPDF from 'jspdf';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import * as html2canvas from 'html2canvas';
import { Observable, Observer } from 'rxjs';
import { StorageService } from '../../shared/services/storage.service';
import { API_ENDPOINTS, API_FUNCTIONS } from '../../shared/constant/apiEndpoint.constant';
import { environment } from '../../../environments/environment';
import { NodeService } from '../../shared/services/node.service';
import { MuteService } from '../../shared/services/mute.service';

@Component({
  selector: 'app-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.css']
})
export class CertificateComponent implements OnInit {
  public url: any;
  base64Image: any;
  public dataURL: any;
  public loading = true;
  public certificateData : any;
  public twitterShareApi = 'https://twitter.com/intent/tweet?text=Check out my Certificate&url=';
  public fbShareAPi = 'http://www.facebook.com/sharer.php?u=';
  public linkedInAPi = 'https://www.linkedin.com/shareArticle?mini=false&url=';
  public loginToken = this.storageService.getFromSessioStorage('loginToken');
  public downloadUrl = environment.apiUrl + API_ENDPOINTS.COMMON_ENDPOINT+"token="+this.storageService.getFromSessioStorage('loginToken')+"&downloadcert=true";
  public wsfunction = API_FUNCTIONS.MY_CERTIFICATES;
  public allAudioTags: any;
  public profileAudio: any;

  @ViewChild('myCanvas') myCanvas: ElementRef;
  @ViewChild('imgId') imgTag: ElementRef;
  public context: CanvasRenderingContext2D;
  constructor(
    private bsModalRef: BsModalRef,
    private api: WebApiService,
    private modalService: BsModalService,
    private storageService: StorageService,
    private nodeService: NodeService,
    private muteService: MuteService) { }

  ngOnInit() {
    this.nodeService.addNode({ modalopen: true });
    this.loginToken = this.storageService.getFromSessioStorage('loginToken');
    this.loadCertificates();
    this.muteService.muteFun();
    this.loadAudio(0);
  }

  public closeCertificate() {
    this.bsModalRef.hide();
  }

  public shareOnTwitter() {
    let twitterShareUrl = environment.apiUrl+'/twitter_share.php?img_url=' + this.url;
    twitterShareUrl = this.twitterShareApi + twitterShareUrl;
    window.open(twitterShareUrl, 'twitter-popup', 'toolbar=0,status=0,width=600,height=350'); return false;
  }

  public shareOnFb() {
    let facebookShareUrl = environment.apiUrl+'/facebook_share.php?img_url=' + this.url;
    facebookShareUrl = this.fbShareAPi + facebookShareUrl;
    window.open(facebookShareUrl, 'sharer', 'toolbar=0,status=0,width=600,height=350'); return false;
  }

  public shareOnLinkedIn() {
    let linkedInUrl = encodeURIComponent(environment.apiUrl+'/linkedin_share.php?img_url=' + this.url);
    linkedInUrl = this.linkedInAPi + linkedInUrl;
    window.open(linkedInUrl, 'sharer', 'toolbar=0,status=0,width=600,height=350'); return false;
  }
  /**
   * 
   * method for showing the user certificate
   */
   loadCertificates() {
    const requestDataMyLearning = {
      endPoint: API_ENDPOINTS.COMMON_ENDPOINT,
      data: {
        token: this.loginToken
      },
      params: {
        token: this.loginToken,
        function: API_FUNCTIONS.MY_CERTIFICATES,
        format: 'json'
      }
    };
    this.api.postApiCall(requestDataMyLearning).subscribe(
      (response: any) => {

        this.modalService.hide(this.modalService.getModalsCount());
        this.certificateData = response.certificates;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        this.modalService.hide(this.modalService.getModalsCount());
      });
  }

  loadAudio(eleNo) {
    this.profileAudio = <HTMLAudioElement>document.getElementById('myProfileAudio');
    /**
     * ToDo:
     */
    switch (eleNo) {
      case 0: this.profileAudio.src = '../../assets/audio/myprofile/certifiacte/Certificate_Instructions.mp3';
        break;
      case 1: this.profileAudio.src = '../../assets/audio/shared/Close_Button.mp3';
        break;
      case 2: this.profileAudio.src = '../../assets/audio/myprofile/certifiacte/Share_Certificate_on_LinkedIn_Button.mp3';
        break;
      case 3: this.profileAudio.src = '../../assets/audio/myprofile/certifiacte/Share_Certificate_on_Twitter.mp3';
        break;
      case 4: this.profileAudio.src = '../../assets/audio/myprofile/certifiacte/Share_Certificate_on_Facebook_Button.mp3';
        break;
      case 5: this.profileAudio.src = '../../assets/audio/myprofile/certifiacte/DownloadCertificateButton.mp3'
        break;
      default: this.profileAudio.src = '';
    }
  }
  public closeModal() {
    this.bsModalRef.hide();
    this.nodeService.addNode({ modalopen: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/myprofile/certificate/certificate.component.ts